module.exports = __webpack_public_path__ + "img/4exp.909beaba.jpg";